import { Div, Flex, Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'

import { Button } from 'src/design_system/components/Button/Button'
import { useAccount, useContainerWidth } from 'src/hooks'

type GratitudeMovementWidgetType = {
  title: string
  isMobile?: boolean
  isTablet?: boolean
}

const GRATITUDE_MOVEMENT_IMAGE_URL =
  'https://soc-website-public.s3.us-west-2.amazonaws.com/static/soc-website/images/manual/GMopp-Thumbnail600.png'

export const GratitudeMovementWidget: React.FC<GratitudeMovementWidgetType> = ({
  title,
  isMobile,
  isTablet,
}) => {
  const [containerRef] = useContainerWidth()

  const account = useAccount()

  return (
    <Flex
      width="100%"
      flexDirection="column"
      backgroundColor="#fff"
      alignItems="center"
      borderRadius="32px"
      minWidth="340px"
      height="inherit"
      inset="16px"
      style={{ boxShadow: 'rgba(0, 0, 0, 0.04) 0px 4px 32px' }}
    >
      <Flex width="100%" justifyContent="center" alignItems="center">
        <Flex>
          <div
            style={{
              width: '100%',
              borderRadius: '20px',
              cursor: 'pointer',
              overflow: 'hidden',
            }}
            onClick={() =>
              window.open(
                `https://promptings.com/presentation?sponsor=${account.genealogyId}`,
                '_blank',
              )
            }
          >
            <img
              src={GRATITUDE_MOVEMENT_IMAGE_URL}
              alt="Gratitude movement"
              style={{
                display: 'block',
                width: '100%',
                height: 'auto',
              }}
            />
          </div>
        </Flex>
      </Flex>
      <Div
        ref={containerRef}
        display="flex"
        width="100%"
        inset="16px"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <Text
          type="subtitle"
          weight="semiBold"
          alignment="left"
          content={title}
        />
      </Div>
      <Flex
        width="100%"
        inset={{ vertical: 'x1', horizontal: 'x2' }}
        justifyContent="center"
        alignItems="center"
      >
        <Button
          title={'Go To Presentation'}
          background="#424448"
          textColor="#FFF"
          textSize={'12px'}
          whiteSpace="nowrap"
          width="100%"
          onClick={() =>
            window.open(
              `https://promptings.com/presentation?sponsor=${account.genealogyId}`,
              '_blank',
            )
          }
        />
      </Flex>
    </Flex>
  )
}
